import { useSelector } from 'react-redux'

import { selectListsStore } from 'redux/selectors/Lists'

export const useListsStore = () => {
  return useSelector(selectListsStore)
}
